module.exports = __webpack_public_path__ + "media/images/smart_phone/shares/202001/ft-e2fd5e59c5fe88b458b8a7967a8f9e82.png";